import moment from "moment"
import { DatePicker } from "antd"

const { RangePicker } = DatePicker

const DateRangePicker = ({ isClearable = true, selectRange, ranges }) => 
    <RangePicker
        value={ ranges }
        onChange={selectRange}
        allowClear={ isClearable }
        ranges={{
            'Today': [moment().startOf('day'), moment().endOf('day')],
            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
            'This Week': [moment().startOf('week'), moment().endOf('week')],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
        }} />

export default DateRangePicker